import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import history from '../config/history';
import mixpanelConstants from '../constants/mixpanel';

export const resetStep4 = createAction('RESET_STEP4');
export const setStep4Display = createAction('SET_STEP4_DISPLAY');
export const setStep4RoleID = createAction('SET_STEP4_ROLE_ID');
export const setStep4SpecialityID = createAction('SET_STEP4_SPECIALITY_ID');
export const setStep4RoleOptions = createAction('SET_STEP4_ROLE_OPTIONS');
export const setStep4SpecialityOptions = createAction('SET_STEP4_SPECIALITY_OPTIONS');

const initialState = {
	display: 'none',
	role_id: '',
	roleOptions: {},
	speciality_id: '',
	specialityOptions: {}
};

export default handleActions(
	{
		RESET_STEP4: () => initialState,
		SET_STEP4_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_STEP4_ROLE_ID: (state, action) => ({ ...state, role_id: action.payload }),
		SET_STEP4_ROLE_OPTIONS: (state, action) => ({ ...state, roleOptions: action.payload }),
		SET_STEP4_SPECIALITY_ID: (state, action) => ({ ...state, speciality_id: action.payload }),
		SET_STEP4_SPECIALITY_OPTIONS: (state, action) => ({ ...state, specialityOptions: action.payload })
	},
	initialState
);

export const updateUserRoleSpeciality = () => {
	return function (dispatch, getState) {
		const { role_id, speciality_id, roleOptions, specialityOptions } = getState().step4;

		const role = roleOptions.filter((role) => role.id == role_id)[0];
		const speciality = specialityOptions.filter((speciality) => speciality.id == speciality_id)[0];

		if (role_id != '' || speciality_id != '') {
			dispatch(setStep4Display('block'));
			Agent.updateUserRole(parseInt(role_id)).then((response1) => {
				if (response1.ok) {
					Agent.updateUserSpeciality(parseInt(speciality_id)).then((response2) => {
						if (response2.ok) {
							dispatch(setStep4Display('none'));
							trackRoleAndSpeciality(role, speciality, getState());
							history.push('/nurse/registration/complete');
						} else {
							dispatch(setStep4Display('none'));
						}
					});
				} else {
					dispatch(setStep4Display('none'));
				}
			});
		} else {
			history.push('/nurse/registration/complete');
		}
	};
};

function trackRoleAndSpeciality(role, speciality, appState) {
	let userId = appState.user.id;
	mixpanel.identify(userId);
	mixpanel.people.set({
		nurse_role: role.name,
		speciality: speciality.name
	});

	mixpanel.track(mixpanelConstants.ROLES_AND_SPECIALITY_SAVE, {
		nureseRole: role.name,
		speciality: speciality.name
	});
}

export const fetchUserRoleAndSpeciality = () => {
	return function (dispatch) {
		Agent.userinfo().then((response) => {
			if (response.ok) {
				if (response.data) {
					dispatch(
						setStep4RoleID(response.data.role_id != null && response.data.role_id != 0 ? response.data.role_id : '')
					);
					dispatch(
						setStep4SpecialityID(
							response.data.specialty_id != null && response.data.specialty_id != 0 ? response.data.specialty_id : ''
						)
					);
				}
			}
		});
	};
};

export const fetchRoleOptions = () => {
	return function (dispatch) {
		Agent.roleOptions().then((response) => {
			if (response.ok) {
				if (response.data) {
					dispatch(setStep4RoleOptions(response.data));
				}
			}
		});
	};
};

export const fetchSpecialityOptions = () => {
	return function (dispatch) {
		Agent.specialityOptions().then((response) => {
			if (response.ok) {
				if (response.data) {
					dispatch(setStep4SpecialityOptions(response.data));
				}
			}
		});
	};
};
